export const getErrorMessage = (selectedFile) => {
  if (selectedFile.size > 15 * 1024 * 1024) {
    return 'Photo size is too large. Please upload photos 15MB or smaller.';
  }

  if (selectedFile.type === 'image/gif' || selectedFile.type === 'image/heic') {
    return `We don't support <.${(selectedFile.type as string).replace('image/', '')}> file formats.`;
  }

  const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
  if (fileExtension === 'psd') {
    return "We don't support PSD file formats.";
  }

  const supportedTypes = ['image/*'];
  const isSupported = supportedTypes.some((type) => selectedFile.type?.match?.(type));
  if (!isSupported) {
    return "We don't support that file type. Please upload a JPG or PNG.";
  }

  return false;
};
